var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/SelectDependencies/ClassifiersTree/nodesInTree.ts";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { createStore } from 'effector';
export var treeClone$ = createStore([], {
  name: "treeClone$",
  sid: "116ad4"
}); // получаем плоский список ссылок нод дерева

export var nodesInTree$ = treeClone$.map(function (tree) {
  var result = [];

  var recursive = function recursive(items) {
    items.forEach(function (item) {
      result.push({
        id: item.id,
        type: item.type
      });

      if ('children' in item && item.children.length) {
        recursive(item.children);
      }
    });
  };

  recursive(tree);
  return result;
});